export interface MockMovie {
  id: string;
  title: string;
  type: "电影" | "电视剧";
  year: number;
  region: string;
  genres: string[];
  rating: number;
  cover: string;
  description: string;
  director: string;
  cast: string[];
  duration: string;
  status: string;
  views: number;
  updatedAt: string;
  tags: string[];
}

export const genreOptions = [
  "全部",
  "剧情",
  "科幻",
  "动作",
  "悬疑",
  "爱情",
  "喜剧",
  "犯罪",
  "奇幻",
  "历史",
  "冒险",
  "动画",
  "战争",
  "惊悚",
  "家庭",
];

export const regionOptions = ["全部", "华语", "欧美", "日韩", "其他"];

export const yearOptions = ["全部", "2025", "2024", "2023", "2022", "更早"];

export const movies: MockMovie[] = [
  {
    id: "mv-001",
    title: "长夜将尽",
    type: "电影",
    year: 2024,
    region: "华语",
    genres: ["剧情", "悬疑"],
    rating: 8.6,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20movie%20poster%20artwork%20of%20a%20lone%20detective%20standing%20in%20a%20rainy%20neon-lit%20city%20street%20at%20night%2C%20moody%20atmospheric%20lighting%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20clean%20uncluttered%20dark%20background%2C%20dramatic%20silhouette%2C%20high%20detail&width=600&height=900&seq=cover-01&orientation=portrait",
    description:
      "一桩尘封多年的旧案，让退休刑警老周再次走进那条熟悉的长夜。当真相逐渐浮现，他必须在正义与亲情之间做出最后的选择。",
    director: "陈泓宇",
    cast: ["张国锋", "林雨薇", "周成"],
    duration: "122分钟",
    status: "已上映",
    views: 1284000,
    updatedAt: "2024-11-18",
    tags: ["犯罪", "追凶", "人性"],
  },
  {
    id: "mv-002",
    title: "山河故人传",
    type: "电影",
    year: 2025,
    region: "华语",
    genres: ["剧情", "历史"],
    rating: 8.9,
    cover:
      "https://readdy.ai/api/search-image?query=Grand%20cinematic%20historical%20movie%20poster%20of%20a%20vast%20misty%20mountain%20range%20with%20a%20solitary%20traveler%20in%20traditional%20robe%2C%20epic%20atmospheric%20lighting%2C%20muted%20deep%20blue%20and%20ochre%20tones%2C%20clean%20minimal%20background%2C%20sweeping%20composition%2C%20high%20detail%20painting&width=600&height=900&seq=cover-02&orientation=portrait",
    description:
      "跨越三十年的家族史诗。少年离乡，中年归故里，山河依旧，人事已非。一部关于故土、迁徙与记忆的时代画卷。",
    director: "李承远",
    cast: ["王砚辉", "宋雅", "赵启明", "何静"],
    duration: "148分钟",
    status: "已上映",
    views: 986000,
    updatedAt: "2025-03-05",
    tags: ["年代", "家族", "时代"],
  },
  {
    id: "mv-003",
    title: "逆流而上",
    type: "电影",
    year: 2025,
    region: "华语",
    genres: ["动作", "犯罪"],
    rating: 7.8,
    cover:
      "https://readdy.ai/api/search-image?query=High%20tension%20action%20movie%20poster%20of%20a%20sports%20car%20speeding%20through%20a%20rain-soaked%20city%20highway%20at%20night%2C%20dramatic%20motion%20blur%20and%20headlight%20glow%2C%20dark%20blue%20and%20orange%20contrast%2C%20clean%20minimal%20background%2C%20bold%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=cover-03&orientation=portrait",
    description:
      "被诬陷的赛车手为了洗清罪名，被迫重回车坛，与幕后黑手展开一场速度与智谋的较量。",
    director: "徐立",
    cast: ["杜江扬", "柳如烟", "彭浩然"],
    duration: "115分钟",
    status: "已上映",
    views: 1546000,
    updatedAt: "2025-06-22",
    tags: ["赛车", "复仇", "燃"],
  },
  {
    id: "mv-004",
    title: "春江花月夜",
    type: "电影",
    year: 2023,
    region: "华语",
    genres: ["爱情", "剧情"],
    rating: 8.2,
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20movie%20poster%20of%20a%20couple%20standing%20under%20blooming%20cherry%20blossoms%20by%20a%20moonlit%20river%20at%20dusk%2C%20soft%20dreamy%20lighting%2C%20warm%20amber%20and%20soft%20blue%20tones%2C%20clean%20uncluttered%20background%2C%20tender%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=cover-04&orientation=portrait",
    description:
      "两个在异乡打拼的年轻人，在一场春夜的江畔相遇，命运让他们一次次错过，又一次次重逢。",
    director: "苏晚晴",
    cast: ["陈默", "许知夏"],
    duration: "108分钟",
    status: "已上映",
    views: 764000,
    updatedAt: "2023-09-30",
    tags: ["爱情", "都市", "错位"],
  },
  {
    id: "mv-005",
    title: "山海寻踪",
    type: "电影",
    year: 2024,
    region: "华语",
    genres: ["奇幻", "冒险"],
    rating: 8.4,
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20fantasy%20movie%20poster%20of%20ancient%20mythical%20mountains%20with%20a%20mystical%20glowing%20creature%20soaring%20through%20clouds%2C%20ethereal%20lighting%2C%20deep%20blue%20and%20teal%20with%20gold%20accents%2C%20clean%20minimal%20background%2C%20grand%20cinematic%20composition%2C%20high%20detail%20concept%20art&width=600&height=900&seq=cover-05&orientation=portrait",
    description:
      "少年为寻找传说中的神兽足迹，踏上《山海经》里的秘境旅途，在幻境与现实中揭开家族秘密。",
    director: "韩之遥",
    cast: ["林子豪", "白露", "沈千寻"],
    duration: "132分钟",
    status: "已上映",
    views: 1132000,
    updatedAt: "2024-07-14",
    tags: ["东方奇幻", "冒险", "成长"],
  },
  {
    id: "mv-006",
    title: "无声告白",
    type: "电影",
    year: 2025,
    region: "华语",
    genres: ["悬疑", "犯罪"],
    rating: 8.1,
    cover:
      "https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20poster%20of%20an%20empty%20dim%20interrogation%20room%20with%20a%20single%20metal%20chair%20under%20a%20harsh%20lamp%2C%20cold%20clinical%20lighting%2C%20deep%20blue%20and%20gray%20tones%2C%20clean%20minimal%20background%2C%20tense%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=cover-06&orientation=portrait",
    description:
      "一名聋哑女孩成为唯一目击者，警方必须在无声的世界里拼凑出整起案件的真相。",
    director: "夏岚",
    cast: ["叶清", "傅清明", "罗一鸣"],
    duration: "118分钟",
    status: "已上映",
    views: 972000,
    updatedAt: "2025-05-09",
    tags: ["悬疑", "推理", "反转"],
  },
  {
    id: "mv-007",
    title: "星际回响",
    type: "电影",
    year: 2025,
    region: "欧美",
    genres: ["科幻", "冒险"],
    rating: 8.7,
    cover:
      "https://readdy.ai/api/search-image?query=Sci-fi%20space%20movie%20poster%20of%20a%20lone%20astronaut%20floating%20before%20a%20vast%20colorful%20nebula%2C%20glowing%20stars%20and%20deep%20space%20atmosphere%2C%20deep%20blue%20and%20orange%20cosmic%20tones%2C%20clean%20minimal%20background%2C%20grand%20cinematic%20composition%2C%20hyper%20detailed&width=600&height=900&seq=cover-07&orientation=portrait",
    description:
      "人类收到来自遥远星系的回响信号，一支探险队踏上旅程，却发现回声来自他们自己的过去。",
    director: "Marcus Vale",
    cast: ["Ethan Cole", "Nora Hayes", "Liam Frost"],
    duration: "145分钟",
    status: "已上映",
    views: 2145000,
    updatedAt: "2025-08-01",
    tags: ["太空", "硬科幻", "探索"],
  },
  {
    id: "mv-008",
    title: "暗夜追凶",
    type: "电影",
    year: 2024,
    region: "欧美",
    genres: ["犯罪", "惊悚"],
    rating: 8.0,
    cover:
      "https://readdy.ai/api/search-image?query=Neo-noir%20crime%20movie%20poster%20of%20a%20shadowy%20figure%20in%20a%20trench%20coat%20walking%20down%20a%20wet%20alleyway%20under%20flickering%20streetlights%2C%20moody%20low-key%20lighting%2C%20deep%20blue%20and%20teal%20tones%2C%20clean%20dark%20background%2C%20dramatic%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=cover-08&orientation=portrait",
    description:
      "一名私家侦探接手一桩看似普通的失踪案，却一步步卷入城市地下世界的黑暗漩涡。",
    director: "Jonathan Reed",
    cast: ["David Marsh", "Sofia Lane"],
    duration: "126分钟",
    status: "已上映",
    views: 1348000,
    updatedAt: "2024-10-11",
    tags: ["黑色电影", "连环案", "都市"],
  },
  {
    id: "mv-009",
    title: "最后的信使",
    type: "电影",
    year: 2025,
    region: "欧美",
    genres: ["科幻", "剧情"],
    rating: 8.3,
    cover:
      "https://readdy.ai/api/search-image?query=Dystopian%20sci-fi%20movie%20poster%20of%20a%20weathered%20messenger%20robot%20traveling%20across%20an%20endless%20desert%20wasteland%20carrying%20a%20letter%2C%20dusty%20warm%20lighting%2C%20orange%20and%20deep%20blue%20contrast%2C%20clean%20minimal%20background%2C%20lonely%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=cover-09&orientation=portrait",
    description:
      "在世界崩塌之后，一台老旧的送信机器人仍坚持完成最后一次投递，只为守护一句未说出口的告别。",
    director: "Clara Bennet",
    cast: ["Ryan Pace", "Mila Kuro"],
    duration: "112分钟",
    status: "已上映",
    views: 1089000,
    updatedAt: "2025-07-19",
    tags: ["末世", "温情", "科幻"],
  },
  {
    id: "mv-010",
    title: "永恒花园",
    type: "电影",
    year: 2023,
    region: "欧美",
    genres: ["爱情", "奇幻"],
    rating: 7.9,
    cover:
      "https://readdy.ai/api/search-image?query=Enchanting%20fantasy%20romance%20movie%20poster%20of%20a%20lush%20hidden%20garden%20filled%20with%20glowing%20flowers%20and%20a%20distant%20figure%20in%20a%20flowing%20dress%2C%20magical%20soft%20lighting%2C%20deep%20emerald%20and%20amber%20tones%2C%20clean%20dreamy%20background%2C%20romantic%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=cover-10&orientation=portrait",
    description:
      "一位植物学家在古老庄园里发现了一座只在月圆之夜绽放的花园，那里藏着一段被时间遗忘的爱情。",
    director: "Isabella Moreau",
    cast: ["Noah Sterling", "Aurora Vane"],
    duration: "118分钟",
    status: "已上映",
    views: 682000,
    updatedAt: "2023-12-02",
    tags: ["奇幻爱情", "治愈", "唯美"],
  },
  {
    id: "mv-011",
    title: "风暴之眼",
    type: "电影",
    year: 2024,
    region: "欧美",
    genres: ["动作", "冒险"],
    rating: 7.6,
    cover:
      "https://readdy.ai/api/search-image?query=Adventure%20action%20movie%20poster%20of%20a%20sailing%20ship%20battling%20a%20massive%20storm%20wave%2C%20dramatic%20spray%20and%20dark%20thunderous%20clouds%2C%20deep%20blue%20and%20steel%20gray%20tones%2C%20clean%20minimal%20background%2C%20epic%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=cover-11&orientation=portrait",
    description:
      "一支科考队在南极海域遭遇百年不遇的风暴，船员们必须在绝境中寻找生还的航线。",
    director: "Peter Nolan",
    cast: ["Jack Mercer", "Elena Ruiz"],
    duration: "124分钟",
    status: "已上映",
    views: 913000,
    updatedAt: "2024-05-27",
    tags: ["灾难", "海洋", "求生"],
  },
  {
    id: "mv-012",
    title: "樱花之约",
    type: "电影",
    year: 2024,
    region: "日韩",
    genres: ["爱情", "剧情"],
    rating: 8.0,
    cover:
      "https://readdy.ai/api/search-image?query=Gentle%20romantic%20japanese%20movie%20poster%20of%20a%20traditional%20temple%20surrounded%20by%20blooming%20cherry%20blossom%20trees%20with%20petals%20drifting%20in%20the%20wind%2C%20soft%20spring%20lighting%2C%20pale%20pink%20and%20deep%20blue%20tones%2C%20clean%20minimal%20background%2C%20serene%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=cover-12&orientation=portrait",
    description:
      "每年樱花盛开的时候，她都会回到同一个车站等待一个约定，而今年，等待有了不同的答案。",
    director: "小林和也",
    cast: ["佐藤美咲", "中村悠真"],
    duration: "106分钟",
    status: "已上映",
    views: 756000,
    updatedAt: "2024-03-21",
    tags: ["纯爱", "青春", "治愈"],
  },
  {
    id: "mv-013",
    title: "东京谜案",
    type: "电影",
    year: 2025,
    region: "日韩",
    genres: ["悬疑", "犯罪"],
    rating: 8.2,
    cover:
      "https://readdy.ai/api/search-image?query=Mystery%20crime%20movie%20poster%20of%20a%20crowded%20tokyo%20street%20at%20night%20with%20blurred%20neon%20signs%20and%20a%20lone%20silhouette%20standing%20still%2C%20moody%20atmospheric%20lighting%2C%20deep%20blue%20and%20magenta%20neon%20tones%2C%20clean%20minimal%20background%2C%20tense%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=cover-13&orientation=portrait",
    description:
      "东京接连发生离奇案件，刑警与法医联手追查，发现所有线索都指向十年前的一宗悬案。",
    director: "山田凉介",
    cast: ["木村拓真", "石原里奈", "高桥健"],
    duration: "120分钟",
    status: "已上映",
    views: 1024000,
    updatedAt: "2025-04-16",
    tags: ["推理", "都市", "悬疑"],
  },
  {
    id: "mv-014",
    title: "沉默的证词",
    type: "电影",
    year: 2023,
    region: "日韩",
    genres: ["剧情", "惊悚"],
    rating: 7.7,
    cover:
      "https://readdy.ai/api/search-image?query=Tense%20courtroom%20drama%20movie%20poster%20of%20an%20empty%20witness%20stand%20under%20a%20single%20beam%20of%20light%20with%20long%20shadows%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20blue%20and%20warm%20beige%20tones%2C%20clean%20minimal%20background%2C%20serious%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=cover-14&orientation=portrait",
    description:
      "一桩没有凶器的命案，一段无人愿意作证的沉默，真相藏在每个人欲言又止的眼神里。",
    director: "朴正勋",
    cast: ["玄彬硕", "金多美"],
    duration: "114分钟",
    status: "已上映",
    views: 634000,
    updatedAt: "2023-08-08",
    tags: ["法庭", "人性", "悬疑"],
  },
  {
    id: "mv-015",
    title: "长风渡海",
    type: "电视剧",
    year: 2025,
    region: "华语",
    genres: ["历史", "剧情"],
    rating: 8.5,
    cover:
      "https://readdy.ai/api/search-image?query=Grand%20chinese%20historical%20drama%20poster%20of%20an%20ancient%20wooden%20warship%20sailing%20across%20a%20vast%20sea%20at%20sunset%20with%20sails%20full%2C%20epic%20golden%20lighting%2C%20deep%20blue%20and%20warm%20ochre%20tones%2C%20clean%20minimal%20background%2C%20sweeping%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=cover-15&orientation=portrait",
    description:
      "明朝年间，一支远洋船队奉命出海通商，从东海到西洋，一段波澜壮阔的航海传奇由此展开。",
    director: "孙浩然",
    cast: ["黄志忠", "陈数", "罗晋", "王凯"],
    duration: "全40集",
    status: "更新至第28集",
    views: 3420000,
    updatedAt: "2025-09-20",
    tags: ["古装", "航海", "家国"],
  },
  {
    id: "mv-016",
    title: "都市浮生记",
    type: "电视剧",
    year: 2024,
    region: "华语",
    genres: ["剧情", "家庭"],
    rating: 7.9,
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20poster%20of%20a%20city%20skyline%20at%20dusk%20with%20warm%20window%20lights%20glowing%20in%20tall%20buildings%2C%20soft%20blue%20hour%20lighting%2C%20deep%20blue%20and%20amber%20tones%2C%20clean%20minimal%20background%2C%20reflective%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=cover-16&orientation=portrait",
    description:
      "三组普通家庭在同一栋楼里各自生活，一次意外让他们的命运交织在一起，也照见了都市人的孤独与温度。",
    director: "周楠",
    cast: ["张译", "海清", "姚晨"],
    duration: "全36集",
    status: "已完结",
    views: 2180000,
    updatedAt: "2024-12-15",
    tags: ["都市", "群像", "现实"],
  },
  {
    id: "mv-017",
    title: "迷雾追凶",
    type: "电视剧",
    year: 2025,
    region: "华语",
    genres: ["悬疑", "犯罪"],
    rating: 8.4,
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20crime%20thriller%20poster%20of%20a%20foggy%20pine%20forest%20with%20a%20narrow%20winding%20path%20and%20a%20distant%20flashlight%20beam%2C%20cold%20misty%20lighting%2C%20deep%20blue%20and%20teal%20tones%2C%20clean%20minimal%20background%2C%20suspenseful%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=cover-17&orientation=portrait",
    description:
      "一座被浓雾笼罩的小镇，每隔七年就会有人失踪。年轻刑警抽丝剥茧，揭开小镇掩藏多年的秘密。",
    director: "韩磊",
    cast: ["白宇", "谭卓", "李现"],
    duration: "全24集",
    status: "更新至第12集",
    views: 2760000,
    updatedAt: "2025-09-28",
    tags: ["悬疑", "小镇", "推理"],
  },
  {
    id: "mv-018",
    title: "医者仁心",
    type: "电视剧",
    year: 2023,
    region: "华语",
    genres: ["剧情"],
    rating: 8.1,
    cover:
      "https://readdy.ai/api/search-image?query=Medical%20drama%20poster%20of%20a%20quiet%20hospital%20corridor%20bathed%20in%20soft%20morning%20light%20with%20a%20distant%20doctor%20silhouette%2C%20gentle%20warm%20lighting%2C%20deep%20blue%20and%20soft%20white%20tones%2C%20clean%20minimal%20background%2C%20hopeful%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=cover-18&orientation=portrait",
    description:
      "急诊科里每一分钟都是与死神的赛跑。一位理想主义医生在现实与信念之间，坚守着最初的誓言。",
    director: "刘慧敏",
    cast: ["靳东", "袁泉", "王阳"],
    duration: "全32集",
    status: "已完结",
    views: 1890000,
    updatedAt: "2023-11-30",
    tags: ["医疗", "职业", "现实"],
  },
  {
    id: "mv-019",
    title: "江湖夜雨",
    type: "电视剧",
    year: 2025,
    region: "华语",
    genres: ["动作", "历史"],
    rating: 8.3,
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20wuxia%20drama%20poster%20of%20a%20swordsman%20standing%20in%20a%20bamboo%20forest%20during%20heavy%20rain%20with%20drawn%20sword%2C%20dramatic%20moody%20lighting%2C%20deep%20green%20and%20blue%20tones%2C%20clean%20minimal%20background%2C%20dynamic%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=cover-19&orientation=portrait",
    description:
      "乱世之中，一把失落的古剑牵动三方势力。落魄剑客与神秘女子结伴同行，揭开江湖背后的滔天阴谋。",
    director: "陈皓",
    cast: ["肖战", "杨紫", "胡歌"],
    duration: "全30集",
    status: "更新至第20集",
    views: 2980000,
    updatedAt: "2025-10-02",
    tags: ["武侠", "古装", "阴谋"],
  },
  {
    id: "mv-020",
    title: "权力深渊",
    type: "电视剧",
    year: 2024,
    region: "欧美",
    genres: ["剧情", "历史"],
    rating: 8.8,
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20political%20drama%20poster%20of%20an%20opulent%20empty%20throne%20room%20with%20tall%20stone%20columns%20and%20flickering%20candlelight%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20blue%20and%20gold%20tones%2C%20clean%20minimal%20background%2C%20regal%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=cover-20&orientation=portrait",
    description:
      "一个家族的兴衰，一段权力的游戏。当王座之下的阴影逐渐吞噬一切，没有人能全身而退。",
    director: "Robert Hale",
    cast: ["James Whitmore", "Claire Doyle", "Oliver Grant"],
    duration: "全20集",
    status: "已完结",
    views: 3860000,
    updatedAt: "2024-09-12",
    tags: ["权谋", "家族", "史诗"],
  },
  {
    id: "mv-021",
    title: "未来边缘",
    type: "电视剧",
    year: 2025,
    region: "欧美",
    genres: ["科幻", "惊悚"],
    rating: 8.5,
    cover:
      "https://readdy.ai/api/search-image?query=Cyberpunk%20sci-fi%20series%20poster%20of%20a%20towering%20futuristic%20city%20filled%20with%20neon%20lights%20and%20flying%20vehicles%20under%20a%20dark%20sky%2C%20glowing%20cyan%20and%20orange%20neon%20tones%2C%20clean%20minimal%20background%2C%20dense%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=cover-21&orientation=portrait",
    description:
      "在不远的未来，人类意识可以上传云端。当系统开始出现无法解释的错误，一个程序员发现了世界的真相。",
    director: "Anna West",
    cast: ["Lucas Gray", "Zoe Park", "Daniel Reed"],
    duration: "全10集",
    status: "更新至第8集",
    views: 2240000,
    updatedAt: "2025-09-15",
    tags: ["赛博朋克", "AI", "悬疑"],
  },
  {
    id: "mv-022",
    title: "猩红之幕",
    type: "电视剧",
    year: 2023,
    region: "欧美",
    genres: ["悬疑", "惊悚"],
    rating: 7.8,
    cover:
      "https://readdy.ai/api/search-image?query=Theatrical%20mystery%20poster%20of%20a%20heavy%20crimson%20velvet%20stage%20curtain%20parting%20slightly%20with%20warm%20spotlight%20glow%2C%20dramatic%20moody%20lighting%2C%20deep%20red%20and%20dark%20blue%20tones%2C%20clean%20minimal%20background%2C%20mysterious%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=cover-22&orientation=portrait",
    description:
      "一家老牌剧院里，每场演出都伴随着一桩离奇事件。神秘的幕后操纵者，正悄悄改写着剧本的结局。",
    director: "Sophia Klein",
    cast: ["Henry Cole", "Ivy Rose"],
    duration: "全12集",
    status: "已完结",
    views: 1320000,
    updatedAt: "2023-10-25",
    tags: ["悬疑", "剧场", "反转"],
  },
  {
    id: "mv-023",
    title: "首尔恋人",
    type: "电视剧",
    year: 2025,
    region: "日韩",
    genres: ["爱情", "喜剧"],
    rating: 7.9,
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20korean%20drama%20poster%20of%20a%20lively%20seoul%20street%20at%20blue%20hour%20with%20warm%20lights%20and%20a%20couple%20walking%20hand%20in%20hand%2C%20soft%20warm%20lighting%2C%20pale%20pink%20and%20deep%20blue%20tones%2C%20clean%20minimal%20background%2C%20sweet%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=cover-23&orientation=portrait",
    description:
      "一档恋爱综艺里，两个性格相反的嘉宾被强行配对。镜头之外，一段真实的爱情却悄然萌芽。",
    director: "金志勋",
    cast: ["朴叙俊", "金泰梨", "李到晛"],
    duration: "全16集",
    status: "更新至第16集",
    views: 2680000,
    updatedAt: "2025-08-28",
    tags: ["甜宠", "都市", "青春"],
  },
  {
    id: "mv-024",
    title: "深夜食堂奇谭",
    type: "电视剧",
    year: 2024,
    region: "日韩",
    genres: ["剧情", "家庭"],
    rating: 8.6,
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20japanese%20drama%20poster%20of%20a%20small%20warm%20restaurant%20at%20night%20with%20glowing%20paper%20lanterns%20and%20steaming%20food%2C%20intimate%20warm%20lighting%2C%20amber%20and%20deep%20blue%20tones%2C%20clean%20minimal%20background%2C%20nostalgic%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=cover-24&orientation=portrait",
    description:
      "午夜十二点才开门的小食堂，每一道菜背后都是一段人生故事。老板只听，不说，却治愈了每一个深夜来客。",
    director: "松重丰和",
    cast: ["小林薰", "上野树里"],
    duration: "全16集",
    status: "已完结",
    views: 1560000,
    updatedAt: "2024-06-18",
    tags: ["治愈", "美食", "温情"],
  },
  {
    id: "mv-025",
    title: "王国密使",
    type: "电视剧",
    year: 2025,
    region: "日韩",
    genres: ["奇幻", "历史"],
    rating: 8.4,
    cover:
      "https://readdy.ai/api/search-image?query=Fantasy%20historical%20drama%20poster%20of%20an%20ancient%20korean%20palace%20at%20night%20illuminated%20by%20torches%20with%20a%20cloaked%20envoy%20walking%20alone%2C%20dramatic%20moody%20lighting%2C%20deep%20blue%20and%20warm%20gold%20tones%2C%20clean%20minimal%20background%2C%20mysterious%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=cover-25&orientation=portrait",
    description:
      "背负密令的使者在宫中步步为营，白天他是无名书吏，夜晚他是游走于权力与阴谋之间的密探。",
    director: "李炳宪",
    cast: ["金秀贤", "徐睿知"],
    duration: "全16集",
    status: "更新至第10集",
    views: 1980000,
    updatedAt: "2025-09-30",
    tags: ["宫廷", "奇幻", "权谋"],
  },
  {
    id: "mv-026",
    title: "极地远征",
    type: "电影",
    year: 2024,
    region: "其他",
    genres: ["冒险", "剧情"],
    rating: 8.2,
    cover:
      "https://readdy.ai/api/search-image?query=Documentary%20adventure%20poster%20of%20a%20vast%20frozen%20arctic%20ice%20landscape%20with%20a%20tiny%20expedition%20team%20and%20sleds%20crossing%20the%20snow%2C%20crisp%20cold%20lighting%2C%20icy%20blue%20and%20soft%20white%20tones%2C%20clean%20minimal%20background%2C%20epic%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=cover-26&orientation=portrait",
    description:
      "一支国际科考队徒步穿越北极冰盖，用镜头记录下人类在极端环境中求生的勇气与自然的壮美。",
    director: "Ola Norheim",
    cast: ["纪录片旁白: 周涛"],
    duration: "135分钟",
    status: "已上映",
    views: 876000,
    updatedAt: "2024-04-22",
    tags: ["纪录片", "极地", "自然"],
  },
  {
    id: "mv-027",
    title: "云端之城",
    type: "电影",
    year: 2025,
    region: "其他",
    genres: ["动画", "奇幻"],
    rating: 8.7,
    cover:
      "https://readdy.ai/api/search-image?query=Animated%20fantasy%20movie%20poster%20of%20a%20dreamy%20city%20floating%20among%20soft%20clouds%20with%20bridges%20and%20airships%2C%20whimsical%20golden%20lighting%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20clean%20minimal%20background%2C%20imaginative%20cinematic%20composition%2C%20high%20detail%20animation%20art&width=600&height=900&seq=cover-27&orientation=portrait",
    description:
      "在漂浮于云端的城市里，一个梦想飞行的女孩与神秘机械师相遇，共同踏上寻找失落家园的旅程。",
    director: "宫崎骏远",
    cast: ["配音: 花泽香菜", "配音: 神谷浩史"],
    duration: "118分钟",
    status: "已上映",
    views: 1720000,
    updatedAt: "2025-07-08",
    tags: ["动画", "治愈", "冒险"],
  },
  {
    id: "mv-028",
    title: "时间旅人",
    type: "电影",
    year: 2023,
    region: "其他",
    genres: ["科幻", "爱情"],
    rating: 8.1,
    cover:
      "https://readdy.ai/api/search-image?query=Surreal%20sci-fi%20romance%20poster%20of%20a%20giant%20melting%20clock%20and%20a%20lone%20figure%20walking%20through%20a%20distorted%20dreamlike%20city%2C%20ethereal%20lighting%2C%20deep%20blue%20and%20soft%20violet%20tones%2C%20clean%20minimal%20background%2C%20mind-bending%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=cover-28&orientation=portrait",
    description:
      "他无法停止穿越时间，唯一能改变的，是每次相遇后她眼中一闪而过的熟悉。一场逆着时间而行的爱情。",
    director: "Alejandro Ruiz",
    cast: ["Tom Hardy", "Emma Stone"],
    duration: "126分钟",
    status: "已上映",
    views: 1460000,
    updatedAt: "2023-07-19",
    tags: ["时空", "爱情", "烧脑"],
  },
  {
    id: "mv-029",
    title: "荒野归途",
    type: "电影",
    year: 2024,
    region: "其他",
    genres: ["冒险", "剧情"],
    rating: 7.9,
    cover:
      "https://readdy.ai/api/search-image?query=Rugged%20wilderness%20adventure%20poster%20of%20a%20lone%20hiker%20on%20a%20mountain%20trail%20overlooking%20a%20sea%20of%20misty%20pine%20forest%20at%20dawn%2C%20soft%20golden%20lighting%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20clean%20minimal%20background%2C%20inspiring%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=cover-29&orientation=portrait",
    description:
      "为了走出内心的阴影，一个失去方向的男人背上行囊徒步穿越原始森林，在荒野中重新找回自己。",
    director: "Sam Everts",
    cast: ["Chris Bell", "Maya Ford"],
    duration: "110分钟",
    status: "已上映",
    views: 720000,
    updatedAt: "2024-08-30",
    tags: ["治愈", "徒步", "成长"],
  },
  {
    id: "mv-030",
    title: "霓虹之下",
    type: "电影",
    year: 2025,
    region: "华语",
    genres: ["剧情", "犯罪"],
    rating: 8.3,
    cover:
      "https://readdy.ai/api/search-image?query=Neon-soaked%20crime%20drama%20poster%20of%20a%20moody%20bar%20interior%20with%20colorful%20neon%20signs%20reflecting%20on%20wet%20pavement%20and%20a%20lone%20barman%20silhouette%2C%20cinematic%20low-key%20lighting%2C%20deep%20blue%20and%20magenta%20orange%20neon%20tones%2C%20clean%20minimal%20background%2C%20stylish%20composition%2C%20high%20detail&width=600&height=900&seq=cover-30&orientation=portrait",
    description:
      "霓虹闪烁的深夜酒吧里，每个人都在隐藏些什么。一位落魄调酒师意外卷入一桩交易，从此无法抽身。",
    director: "梁牧",
    cast: ["王传君", "周迅", "张震"],
    duration: "118分钟",
    status: "已上映",
    views: 1620000,
    updatedAt: "2025-09-10",
    tags: ["犯罪", "都市", "悬疑"],
  },
];

export const heroSlides = [
  {
    id: "mv-007",
    title: "星际回响",
    subtitle: "跨越星海的回响，来自人类自己的过去",
    tag: "独家热映",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20shot%20of%20a%20lone%20astronaut%20floating%20before%20a%20vast%20colorful%20nebula%20filled%20with%20glowing%20stars%20in%20deep%20space%2C%20dramatic%20atmospheric%20lighting%2C%20deep%20blue%20and%20warm%20orange%20cosmic%20tones%2C%20stylized%20artistic%20concept%20art%2C%20high%20detail%2C%20cinematic%20composition&width=1600&height=900&seq=hero-01&orientation=landscape",
  },
  {
    id: "mv-015",
    title: "长风渡海",
    subtitle: "从东海到西洋，一段波澜壮阔的航海传奇",
    tag: "热播剧集",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20shot%20of%20an%20ancient%20chinese%20wooden%20warship%20sailing%20across%20a%20vast%20golden%20sea%20at%20sunset%20with%20sails%20full%2C%20dramatic%20sky%20and%20warm%20lighting%2C%20deep%20blue%20and%20ochre%20tones%2C%20stylized%20artistic%20concept%20art%2C%20high%20detail%2C%20cinematic%20composition&width=1600&height=900&seq=hero-02&orientation=landscape",
  },
  {
    id: "mv-017",
    title: "迷雾追凶",
    subtitle: "迷雾笼罩的小镇，隐藏着七年的秘密",
    tag: "悬疑推理",
    image:
      "https://readdy.ai/api/search-image?query=Atmospheric%20cinematic%20wide%20shot%20of%20a%20foggy%20pine%20forest%20at%20dusk%20with%20a%20narrow%20winding%20path%20and%20a%20distant%20flashlight%20beam%2C%20cold%20misty%20moody%20lighting%2C%20deep%20blue%20and%20teal%20tones%2C%20stylized%20artistic%20concept%20art%2C%20high%20detail%2C%20cinematic%20composition&width=1600&height=900&seq=hero-03&orientation=landscape",
  },
  {
    id: "mv-027",
    title: "云端之城",
    subtitle: "漂浮在云端之上的梦想与冒险",
    tag: "动画佳片",
    image:
      "https://readdy.ai/api/search-image?query=Dreamy%20animated%20cinematic%20wide%20shot%20of%20a%20floating%20city%20among%20soft%20golden%20clouds%20with%20bridges%20and%20airships%2C%20whimsical%20warm%20lighting%2C%20deep%20blue%20and%20amber%20tones%2C%20stylized%20artistic%20animation%20art%2C%20high%20detail%2C%20cinematic%20composition&width=1600&height=900&seq=hero-04&orientation=landscape",
  },
];

export const topics = [
  {
    id: "topic-1",
    name: "年度佳片精选",
    desc: "2025 年度口碑与人气兼具的代表作品",
    count: 12,
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20artistic%20collection%20poster%20of%20golden%20film%20award%20trophies%20and%20cinema%20reels%20among%20warm%20spotlight%20beams%2C%20elegant%20luxurious%20lighting%2C%20deep%20blue%20and%20gold%20tones%2C%20clean%20minimal%20background%2C%20premium%20cinematic%20composition%2C%20high%20detail&width=800&height=600&seq=topic-01&orientation=landscape",
  },
  {
    id: "topic-2",
    name: "经典必看系列",
    desc: "那些值得反复回味的影史经典之作",
    count: 24,
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20artistic%20vintage%20cinema%20poster%20of%20a%20classic%20retro%20film%20projector%20casting%20warm%20light%20into%20a%20dark%20room%2C%20nostalgic%20moody%20lighting%2C%20deep%20blue%20and%20sepia%20tones%2C%20clean%20minimal%20background%2C%20cinematic%20composition%2C%20high%20detail&width=800&height=600&seq=topic-02&orientation=landscape",
  },
  {
    id: "topic-3",
    name: "悬疑烧脑专题",
    desc: "反转不断，让你一口气看到最后的推理佳作",
    count: 18,
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20artistic%20mystery%20poster%20of%20floating%20magnifying%20glass%20and%20scattered%20puzzle%20pieces%20under%20a%20single%20spotlight%2C%20dramatic%20moody%20lighting%2C%20deep%20blue%20and%20teal%20tones%2C%20clean%20minimal%20background%2C%20suspenseful%20composition%2C%20high%20detail&width=800&height=600&seq=topic-03&orientation=landscape",
  },
  {
    id: "topic-4",
    name: "治愈系暖片",
    desc: "适合深夜独处时静静观看的温柔故事",
    count: 15,
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20artistic%20warm%20healing%20poster%20of%20a%20cozy%20window%20seat%20with%20a%20cup%20of%20tea%20and%20soft%20golden%20sunlight%20streaming%20in%2C%20gentle%20warm%20lighting%2C%20amber%20and%20soft%20blue%20tones%2C%20clean%20minimal%20background%2C%20peaceful%20composition%2C%20high%20detail&width=800&height=600&seq=topic-04&orientation=landscape",
  },
];